
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock/[...slug]",
      function () {
        return require("private-next-pages/stock/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock/[...slug]"])
      });
    }
  